export default "__VITE_ASSET__e857684b__"